import { z } from 'zod';

export const ADMIN_WORKER_CAPACITY_MAX_WORKERS = 10_000;
export const ADMIN_WORKER_CAPACITY_MAX_COUNTER = 2_000_000_000;

const BoundedCapacityIntegerSchema = z.number()
  .int()
  .nonnegative()
  .max(ADMIN_WORKER_CAPACITY_MAX_COUNTER);

export const WorkerCapacityCountersSchema = z.object({
  processing: BoundedCapacityIntegerSchema,
  caseWiki: BoundedCapacityIntegerSchema,
  total: BoundedCapacityIntegerSchema,
}).strict().superRefine((counters, context) => {
  if (counters.total !== counters.processing + counters.caseWiki) {
    context.addIssue({
      code: z.ZodIssueCode.custom,
      path: ['total'],
      message: 'worker capacity total must equal processing + caseWiki',
    });
  }
});

export const WorkerCapacityFleetSchema = z.object({
  workerCount: z.number().int().nonnegative().max(ADMIN_WORKER_CAPACITY_MAX_WORKERS),
  configuredWorkerCapacity: BoundedCapacityIntegerSchema,
  caseWikiAdmissionLimit: BoundedCapacityIntegerSchema,
  bullmqActive: WorkerCapacityCountersSchema,
  admission: z.object({
    waiting: WorkerCapacityCountersSchema,
    admitted: WorkerCapacityCountersSchema,
  }).strict(),
}).strict().superRefine((fleet, context) => {
  if (fleet.caseWikiAdmissionLimit > fleet.configuredWorkerCapacity) {
    context.addIssue({
      code: z.ZodIssueCode.custom,
      path: ['caseWikiAdmissionLimit'],
      message: 'fleet Case Wiki admission limit cannot exceed configured worker capacity',
    });
  }
});

export type WorkerCapacityCounters = z.infer<typeof WorkerCapacityCountersSchema>;
export type WorkerCapacityFleet = z.infer<typeof WorkerCapacityFleetSchema>;
